//컬럼 정의
export const _columns = [
  {
    field: "monTargetNo",
    headerName: "서버 번호",
    width: 80,
  },

  {
    field: "monTargetNm",
    headerName: "이름",
    width: 150,
  },
  {
    field: "useYn",
    headerName: "사용중",
    width: 80,
    valueGetter: (params) => {
      return params.row.useYn === "Y" ? "O" : "X";
    },
  },
  {
    field: "chkClNm",
    headerName: "유형",
    width: 100,
  },
  {
    field: "ipAddrVal",
    headerName: "주소",
    width: 180,
    valueGetter: (params) => {
      return params.row.ipAddrVal || params.row.urlVal;
    },
  },
  {
    field: "chkIntervalMin",
    headerName: "점검 주기",
    width: 130,
  },
  {
    field: "selectedCheck",
    headerName: "점검 항목",
    width: 250,
    valueGetter: (params) => {
      const {
        usePingChkYn,
        useLatencyChkYn,
        useCpuChkYn,
        useHttpChkYn,
        useDiskChkYn,
        useMemoryChkYn,
        useDataCntChkYn,
      } = params.row;

      const trueValues = [];
      if (usePingChkYn === "Y") trueValues.push("ping");
      if (useLatencyChkYn === "Y") trueValues.push("latency");
      if (useCpuChkYn === "Y") trueValues.push("cpu");
      if (useHttpChkYn === "Y") trueValues.push("http");
      if (useDiskChkYn === "Y") trueValues.push("disk");
      if (useMemoryChkYn === "Y") trueValues.push("memory");
      if (useDataCntChkYn === "Y") trueValues.push("수집건수");

      return trueValues.join(", ");
    },
  },
];

export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const columns5_5 = managerColumns(_columns);
